/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface PopulateSimilarIncidentRulesDto {
  /**
   * Device IDs to distribute this incident rule to (must belong to the client; the source device is ignored if listed)
   * @minItems 1
   */
  targetDeviceIds: unknown[][];
  /** When true, update existing non-system rules for the same datapoint; when false, skip those devices */
  replaceExisting?: boolean;
  /** When true, return the same summary without writing to the database */
  dryRun?: boolean;
}
